<script setup lang="ts">
/* Logo Arkyan animé — repris tel quel de app/components/LoadingSpinner.vue
 * (SVG + keyframes). Seuls écarts : le trait prend la couleur de marque sous
 * son nouveau nom `stroke-brand` (spec §4.3) et le `stroke-linecap` passe par
 * l'attribut SVG, qui est la forme correcte. */
import { computed } from 'vue';
import { SpinnerSize } from '@/shared/enums';

const props = withDefaults(defineProps<{
  message?: string;
  size?: SpinnerSize;
}>(), {
  message: 'Chargement...',
  size: SpinnerSize.Md,
});

const messageClass = computed(() => ({
  [SpinnerSize.Sm]: 'mt-3 text-xs',
  [SpinnerSize.Md]: 'mt-4 text-sm',
  [SpinnerSize.Lg]: 'mt-4 text-sm',
}[props.size]));
</script>

<template>
  <div class="flex flex-col items-center justify-center">
    <svg
      viewBox="0 0 100 84.33"
      class="loader mx-auto stroke-brand stroke-[2]"
      stroke-linecap="round"
    >
      <g class="dash">
        <path d="M55.88,4c4.69,0,8.51.28,10.91.52,7.83.72,15.12,3.15,20.53,6.87,5.53,3.76,8.45,8.31,8.67,13.49.22,5.64-3.8,13.36-15.78,18.13-2.39.95-4.85,1.66-7.35,2.11-.46.09-1,.17-1.69.27-.56.08-1.19.18-1.93.29-5.59.77-12.12,1.83-18.45,3.88-.53.09-1.02.28-1.46.56-3.82,1.39-7.32,3.32-9.14,5.05-1.5,1.39-2.09,3.29-1.57,5.11.58,2.03,2.48,3.45,4.62,3.45h.22c.47.03.96.05,1.45.05,3.69,0,7.56-.85,13.57-2.25,2.01-.47,4.28-.72,6.57-.72,2.86,0,5.64.39,7.81,1.08,4.22,1.39,6.92,2.64,9.85,5.54,3.24,3.68,5.49,8.8,6.88,12.81h-12.97c-.96-2.31-2-4.14-3.2-5.64-.02-.03-.05-.06-.08-.09-1.19-1.4-2.49-2.34-3.99-2.86-.02,0-.04-.02-.07-.02-.93-.31-1.98-.47-3.11-.47s-2.35.15-3.65.46c-7.12,1.64-12.85,2.44-17.53,2.44-.82,0-1.61-.03-2.36-.08-.02,0-.04,0-.05,0-3.58-.19-6.45-.95-8.82-2.34-3.05-1.75-5.15-4.57-5.91-7.95-1.33-5.97.41-11.48,5.04-15.92,3.25-3.09,7.82-5.61,13.96-7.7,4.7-1.56,10.32-2.87,17.21-4,1.77-.29,3.32-.52,4.57-.71.2,0,.39-.02.59-.05.94-.16,1.51-.23,1.66-.25.08,0,.15-.02.23-.04,7.95-1.46,10.05-6.87,10.05-9.53,0-.15,0-.3-.02-.44-.21-1.92-1.23-3.64-3.03-5.11-.05-.04-.1-.08-.15-.12-2.9-2.15-7.01-3.49-12.24-4-3.15-.29-6.37-.44-9.56-.44-6.13,0-12.16.55-17.43,1.6-2.57.51-4.96,1.13-7.13,1.86-3.9,1.33-15.76,5.39-15.76,17.24v44.24H4v-44.24c0-6.99,2.38-13.03,7.07-17.95,5.08-5.32,11.92-8.4,16.78-10.05,9.92-3.38,20.72-4.09,28.04-4.09Z" />
      </g>
    </svg>
    <p
      class="text-ptext-3 font-mono tracking-wide"
      :class="messageClass"
    >
      {{ message }}
    </p>
  </div>
</template>

<style scoped>
.loader {
  display: block;
  width: 100px;
  height: 84.33px;
  fill: none;
  overflow: visible;
}

.loader .dash path {
  filter: drop-shadow(0 0 2px var(--accent));
  animation: dashArray 2s ease-in-out infinite,
  dashOffset 2s linear infinite;
}

@keyframes dashArray {
  0% { stroke-dasharray: 0 1 359 0; }
  50% { stroke-dasharray: 0 359 1 0; }
  100% { stroke-dasharray: 359 1 0 0; }
}

@keyframes dashOffset {
  0% { stroke-dashoffset: -5; }
  100% { stroke-dashoffset: -365; }
}
</style>
